module.exports = __webpack_public_path__ + "static/img/solutionDetailPic14.a697c19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic14.jpg
// module id = aw1d
// module chunks = 1